import { Card } from "../../components/Card";
import { TableVirtualized } from "../../components/Table";
import "./styles.scss";

export const ContentListScreen = ({ dataTable, onFilter }) => {
  return <>
    <div className="content-list-container">
      <Card className="content-list-card no-border">
        {dataTable && (
          <TableVirtualized
            className="table-assistance"
            onFilter={(_, __, data) => onFilter(data)}
            data={dataTable}
          />
        )}
      </Card>
    </div>
  </>
}